<template>
  <div class="w-full">
    <div class="flex justify-between items-center">
      <label class="vs-input--label" :class="{ 'required': required }">{{ label }}</label>
      <div class="flex items-center cursor-pointer" @click="showPassword = !showPassword">
        <feather-icon
          :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
          size="18"
          class="text-grey-dark"
          style="width: 18px; height: 18px;"
        />
        <span class="ml-2 text-sm text-grey-dark">{{ showPassword ? $t('$General.Hide') : $t('$General.Show') }}</span>
      </div>
    </div>
    <vs-input
      :value="value"
      @input="$emit('input', $event)"
      v-on="$listeners"
      v-bind="$attrs"
      :type="showPassword ? 'text' : 'password'"
      class="w-full"
      :name="name"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
    />
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  inheritAttrs: false,
  i18n: {
    messages: {
      en: {
        '$General.Show': 'Show',
        '$General.Hide': 'Hide',
      },
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
};
</script>
